import orders from './store/orders';
import actitemsinner from './store/actitemsinner';
import actitemsouter from './store/actitemsouter';
import actitemsfavorites from './store/actitemsfavorites';
import protocolonsignlist from './store/protocolonsignlist'
//import protocolonexecutionlist from './store/protocolonexecutionlist'
//import protocolonadjustmentlist from './store/protocolonadjustmentlist'
import protocolontakeoffcontrollist from './store/protocolontakeoffcontrollist'
//import protocoloncontrollist from './store/protocoloncontrollist'
import svetofor from './store/svetofor';

import myordersonexecution from './store/myordersonexecution';
import myordersoncheck from './store/myordersoncheck';
import myordersoncontrol from './store/myordersoncontrol';
import mytasksoncontrol from './store/mytasksoncontrol'
//import myprocessesoncontrol from './store/myprocessesoncontrol';
import myprocessesonadjustment from './store/myprocessesonadjustment';
import protocolonprolongationlist from './store/protocolonprolongationlist';
import protocolsbycurrentperiod from './store/protocolsbycurrentperiod';
import protocolscompleted from './store/protocolscompleted';
import protocolsremovedfromcontrol from './store/protocolsremovedfromcontrol';
import protocolsbypastperiods from './store/protocolsbypastperiods';

const lists = {
    namespaced: true,
    modules: {
        orders,
        actitemsinner,
        actitemsouter,
        actitemsfavorites,
        protocolonsignlist,
        //protocolonexecutionlist,
        //protocolonadjustmentlist,
        protocolontakeoffcontrollist,
        //protocoloncontrollist,
        svetofor,
        myordersonexecution,
        myordersoncheck,
        myordersoncontrol,
        mytasksoncontrol,
        //myprocessesoncontrol,
        myprocessesonadjustment,
        protocolonprolongationlist,
        protocolsbycurrentperiod,
        protocolscompleted,
        protocolsremovedfromcontrol,
        protocolsbypastperiods
    }
}

export default lists;